import React from 'react'
import styled, { css } from 'styled-components'
import Select from 'react-select'

function FormSelect({
  options,
  value,
  onChange,
  placeholder,
  onInputChange,
  isSearchable = false,
  extractValue = 'value',
  disabled,
  withoutBorder,
  label,
  type,
  ...props
}) {
  const handleChange = selectedOption => {
    onChange(selectedOption[extractValue], type)
  }

  return (
    <Wrap withoutBorder={withoutBorder} {...props}>
      {label && <LabelName> {label}</LabelName>}
      <Select
        value={options.find(option => option.value == value)}
        options={options}
        placeholder={placeholder}
        onChange={handleChange}
        filterOption={() => true}
        isSearchable={isSearchable}
        labelKey="label"
        valueKey="value"
        variant="default"
        className={'select-form'}
        onInputChange={onInputChange}
        // menuIsOpen={true}
        isDisabled={disabled}
        {...props}
      />
    </Wrap>
  )
}

export default FormSelect
const LabelName = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
  padding-bottom: 12px;
`
const Wrap = styled.div`
  font-size: 13px;
  
  .css-yk16xz-control {
    min-height: 42px;
  }
  
  .css-1pahdxg-control {
    border-color: #ffd54c !important;
    min-height: 42px;
  }

  .css-9gakcf-option {
    font-weight: 700;
    background: #ffd54c;
    color: #333333;
  }

  ${p =>
    p.withoutBorder &&
    css`
      .css-14ojxsb-control,
      .css-1szy77t-control,
      .css-bg1rzq-control {
        padding-left: 0 !important;
        height: auto;
        border: none;
        font-size: 14px;
      }
    `}

  ${p =>
    p.borderBottom &&
    css`
      .css-14ojxsb-control,
      .css-1szy77t-control,
      .css-bg1rzq-control {
        border-bottom: 1px solid #fff !important;
      }
    `}

  ${p =>
    p.transparent &&
    css`
      .css-14ojxsb-control,
      .css-1szy77t-control,
      .css-bg1rzq-control {
        background: transparent;

        svg {
          fill: #fff !important;
        }
      }

      .css-dvua67-singleValue {
        color: #fff;
      }
    `}
`
